import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { BillAccountsService } from '../services/bill-accounts.service';
import {
  billAccountsLoadFromExpAPI,
  billAccountsLoadFromExpApiFail,
  billAccountsLoadFromExpApiSuccess
} from './billaccountExp.actions';

export const loadFromExpAPI = createEffect(
  (action$ = inject(Actions), billingService = inject(BillAccountsService)) => {
    return action$.pipe(
      ofType(billAccountsLoadFromExpAPI),
      switchMap(() =>
        billingService.getBillAccountsFromExpApi().pipe(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          map((fetchedBillAccount: any) => {
            if (fetchedBillAccount['response'] === null) {
              return billAccountsLoadFromExpApiSuccess([]);
            }

            return billAccountsLoadFromExpApiSuccess(fetchedBillAccount['response'].billaccounts);
          }),
          catchError(error => {
            return of(billAccountsLoadFromExpApiFail(error));
          })
        )
      )
    );
  },
  { functional: true }
);
